import type { MediaImage, ModuleKey, Profile } from "./terra-boa-data";

export const distributorMarkets: ModuleKey[] = ["hortifruti", "graos", "pecuaria", "compras"];
export const campaignTypes = ["page", "promotion", "popup"] as const;
export type DistributorCampaignType = typeof campaignTypes[number];
export type DistributorSponsor = {
  profileId: string;
  active: boolean;
  startsOn: string;
  endsOn: string;
  modules: ModuleKey[];
  showInQuickFilter: boolean;
  showOnLoading: boolean;
  permissions: Record<DistributorCampaignType, { allowed: boolean; limit: number }>;
  updatedAt?: unknown;
};
export type DistributorCampaign = {
  id: string;
  profileId: string;
  ownerUid: string;
  type: DistributorCampaignType;
  module: ModuleKey;
  title: string;
  message: string;
  category: string;
  state: string;
  municipality?: string;
  startsOn: string;
  endsOn: string;
  active: boolean;
  coverImage?: MediaImage;
  createdAt?: unknown;
};
export const todayInBrazil = () => { const parts = new Intl.DateTimeFormat("en", { timeZone: "America/Sao_Paulo", year: "numeric", month: "2-digit", day: "2-digit" }).formatToParts(new Date()); return ["year", "month", "day"].map(type => parts.find(part => part.type === type)!.value).join("-"); };
export function sponsorIsCurrent(sponsor: DistributorSponsor, profile?: Profile, today = todayInBrazil()) {
  return Boolean(profile?.role === "DISTRIBUIDOR" && sponsor.active && sponsor.startsOn <= today && sponsor.endsOn >= today);
}
export function campaignIsCurrent(campaign: DistributorCampaign, sponsor: DistributorSponsor, profile?: Profile, today = todayInBrazil()) {
  return sponsorIsCurrent(sponsor, profile, today) && campaign.profileId === sponsor.profileId && campaign.active
    && campaign.startsOn <= today && campaign.endsOn >= today && sponsor.modules.includes(campaign.module)
    && sponsor.permissions[campaign.type]?.allowed === true;
}
export function campaignMatchesRegion(campaign: DistributorCampaign, location: { state?: string; municipality?: string }) {
  const normalize = (value: string) => value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").trim().toLowerCase();
  return (!location.state || location.state === campaign.state)
    && (!location.municipality || !campaign.municipality || normalize(location.municipality) === normalize(campaign.municipality));
}
export function blankSponsor(profileId: string): DistributorSponsor {
  return { profileId, active: false, startsOn: todayInBrazil(), endsOn: todayInBrazil(), modules: [], showInQuickFilter: false, showOnLoading: false,
    permissions: { page: { allowed: false, limit: 0 }, promotion: { allowed: false, limit: 0 }, popup: { allowed: false, limit: 0 } } };
}
